import cookie from 'js-cookie'


/**
 * Highly recommended to not use this method! Use @injectGlobals decorator if possible!
 * Now we use it in actions bcs there is no easy way to pass cookie values from globals...
 *
 * BUT! We should get rid of this method someday coz all places where cookie should be resolved in SSR
 * must be written with @injectGlobals decorator!
 *
 * BUT! :) There is an exception...
 * For example a reducer with code:
 *
 *    export const initialState = {
 *      products: getCookieValue('name') || [],
 *    }
 *
 * This code will cause problem in SSR and should be moved to SSR initialState generation,
 * bcs we don't setup initial state on client side... we use it from SSR (fully). But we'd like to test
 * same behavior with storing and restoring data from cookies on DEV! So we need to leave getCookieValue()
 * in the reducer :)
 *
 * I recommend to pass additional argument to getCookieValue(), second boolean argument to specify that this usage
 * required in DEV process! So:
 *
 *    export const initialState = {
 *      products: getCookieValue('name', true) || [],
 *    }
 *
 * @param {string} cookieName
 * @param {Boolean} [isValidUsage]
 * @returns {*}
 */
const getCookieValue = (cookieName, isValidUsage) => {
  if (!cookieName) {
    console.error('No cookie name!')
  }

  if (process.env.WEBPACK === 'build.client' || process.env.WEBPACK === 'dev') {
    return cookie.getJSON(cookieName)
  }

  if (!isValidUsage) {
    // Replace it with throw new Error() when all places where it used will be found
    console.error('Looks like you are trying use getCookieValue() in SSR! Use @injectGlobals decorator instead!')
  }
}


export default getCookieValue
